import { useState, useEffect } from "react";

const useFormattedCountDown = (seconds) => {
  const [remainingSeconds, setRemainingSeconds] = useState(seconds);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes < 10 ? "0" : ""}${minutes}:${
      secs < 10 ? "0" : ""
    }${secs}`;
  };

  useEffect(() => {
    setRemainingSeconds(seconds);

    if (seconds <= 0) return;

    const timer = setInterval(() => {
      setRemainingSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);

  return {
    formattedTime: formatTime(remainingSeconds),
    remainingSeconds,
  };
};

export default useFormattedCountDown;
